import { processDevicesData } from "./device";
import { processCameraDeviceLocations } from "./crowds";

const BATTERY_THRESHOLD = 25;

function sortById(a, b) {
    return a.group_id - b.group_id;
}

export function processSubgroupData(group, devices, show_inactive) {

    if (devices != null) {
        group.uuids = [];

        for (var subgroup of group.subgroups) {
            subgroup.devices_monitored = 0;
            var subgroup_devices = devices.filter(function (row) {
                return subgroup.uuids.indexOf(row.uuid) > -1;
            });

            subgroup.devices = processDevicesData(subgroup_devices, show_inactive, group.type);
            subgroup = getUpdatedStats(subgroup);

            for (var uuid of subgroup.uuids) {
                group.uuids = group.uuids.concat(uuid);
            }
        }
    }

    group.subgroups = group.subgroups.sort(sortById);

    return group;
}

export function processParentGroupData(parent_group) {
    var ret = {
        group_id: parent_group.group_id,
        name: parent_group.name,
        geojson: parent_group.geojson,
        organisation_id: parent_group.organisation_id
    };

    return ret;
}

export function getUpdatedStats(group) {
    group.all_updated = true;

    for (var device of group.devices) {
        if (device.active) {
            if (device.connected_state == 'offline') {
                group.all_updated = false;
            }
            if (device.battery <= BATTERY_THRESHOLD) {
                group.devices_monitored++;
            }
        }
    }

    return group;
}

export function processGroupData(group, devices, show_inactive, camera_locations = false) {
    if (group != null) {
        group.devices_monitored = 0;
        if (group.subgroups.length > 0) {
            group = processSubgroupData(group, devices, show_inactive);
        }

        if (group.parent_group.length > 0) {
            group.parent_group = processParentGroupData(group.parent_group[0]);
        }

        // console.log(devices);

        if (devices != null) {
            var devices_list = devices.filter(function (row) {
                return group.uuids.indexOf(row.uuid) > -1;
            });

            // console.log(devices_list);
            group.devices = processDevicesData(devices_list, show_inactive, group.type);
            if (camera_locations) {
                group.devices = processCameraDeviceLocations(group.devices, camera_locations);
            }
            group = getUpdatedStats(group);
        }
    }

    return group;
}